import { render, staticRenderFns } from "./fieldColumn.vue?vue&type=template&id=721e7e60&scoped=true"
import script from "./fieldColumn.vue?vue&type=script&lang=js"
export * from "./fieldColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721e7e60",
  null
  
)

export default component.exports